import { QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import { Toaster } from 'sonner'
import { client } from '@/lib/query-client'

export const Providers = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={client}>
      <Toaster
        style={{ top: 100 }}
        toastOptions={{ unstyled: true }}
        position="top-right"
      />
      {children}
    </QueryClientProvider>
  )
}
